import cx from 'classnames'

/* eslint-disable-next-line import/no-restricted-paths -- FIXME: UXP-4500 */
import IconButton from '@src/component/IconButton'
/* eslint-disable-next-line import/no-restricted-paths -- FIXME: UXP-4500 */
import Unread from '@src/component/Unread'
import { ArrowDownIcon } from '@ui/icons/tint/16/general'
import { theme } from '@ui/theme'

import * as styles from './ScrollToBottom.css'
import type { ScrollerController } from './useScrollerController'

export interface ScrollToBottomButtonProps {
  controller: ScrollerController
  badgeCount: number
  onClick: () => void
}

const ScrollToBottom = ({
  controller,
  badgeCount,
  onClick,
}: ScrollToBottomButtonProps) => {
  return (
    <div ref={controller.scrollToBottomButtonRef} className={styles.root}>
      {/* eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button */}
      <IconButton
        size={32}
        className={cx(styles.scrollToBottom, styles.animation)}
        rounded
        opaque
        color="primary"
        backgroundColor={`rgb(${theme.palette.background.default})`}
        onClick={onClick}
        icon={<ArrowDownIcon />}
      />
      <Unread
        className={cx(styles.unread, styles.animation)}
        count={badgeCount > 9 ? '9+' : badgeCount}
        color="blue"
      />
    </div>
  )
}

export default ScrollToBottom
